import { ComponentRef, ViewContainerRef } from '@angular/core';
import { PassKeyRegisterFormComponent } from './pass-key-register-form.component';
import { timeout } from 'rxjs/operators';

class RegisterPassKeyFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;
  username: string;
  displayName: string;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  passKeyRegisterFormComponent: ComponentRef<PassKeyRegisterFormComponent>;

  constructor(formId: string, payload: object) {

  }
    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.username =  clientContext['username'];
    this.displayName = clientContext['DisplayName'];
    
    this.setupForm.call(this);
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;


  }
  endSession(): void {

    this.setAsScreen.call(this);
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    // this.passkeyRegister();

    this.passKeyRegisterFormComponent = this.viewContainerRef.createComponent(PassKeyRegisterFormComponent);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          this.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private onSubmitUserData(payload: object) {
    const data = payload;
    this.submitBlock(data);
  }

// async passkeyRegister() {
//     (window as any).tsPlatform.webauthn.isPlatformAuthenticatorSupported().then((results) => {

//       if (results )
//       {
//          (window as any).tsPlatform.webauthn.register('d52073d9-b1df-454e-8ce1-7c589aa7549a', {
//           limitSingleCredentialToDevice: true ,
//           displayName: 'd52073d9-b1df-454e-8ce1-7c589aa7549a' ,
//           allowCrossPlatformAuthenticators: true,
//           registerAsDiscoverable: true}).then((data3) => {



//           this.submitBlock({
//           action: 'submit',
//           webauthntoken: data3
//         });

//         }).catch((error1) => {

//         });
//       }
//       else{

//       }
//     })
//     .catch((error) => {

//     });
//   }

  async passkeyRegister() {
     try {
          const username = this.username;  
          const res = await (window as any).tsPlatform.webauthn.register({username,
            options: {
              limitSingleCredentialToDevice: true,
              displayName: this.displayName,
              allowCrossPlatformAuthenticators: true,
              registerAsDiscoverable: true,
              timeout: 60
            }
          });

        if (res){
          this.submitBlock({
          action: 'submit',
          webauthntoken: res
        });
      }
      else{

          this.submitBlock({
          action: 'submit',
          webauthntoken: null,
          error: 'webauthn.register failed'
        });
      }

    }
    catch (e){
        this.submitBlock({
        action: 'submit',
        webauthntoken: null,
        error: 'Timeout - ' + e
      });
    }
  }

  async setupForm(){
      await this.passkeyRegister();
      // $.get('passkeyregister.html', () => {
      //   // $(self.clientContext.uiContainer).html(data);

      //       $('#passkeyRegister').on('click', () => {
      //       this.passkeyRegister.call(self);

      //       // tslint:disable-next-line:indent
      //       // $('#custom-password-authenticator_cancel-button').on('click', () => {
      //       //   const escapeOptions = self.actionContext.getEscapeOptions();
      //       //   const cancelOption = escapeOptions.filter(option => option.getId() === 'cancel')[0];

      //       //   if (!cancelOption) {
      //       //     return console.error(`unable to find a "Cancel" option in actionContext.escapeOptions`);
      //       //   }
      //       //   self.submitHandler(com.ts.mobile.sdk.InputOrControlResponse.createEscapeResponse(cancelOption));
      //       // });

      //       // const showInModal = self.payload.showInModal;
      //       // if (showInModal && showInModal === true) {
      //       //     setAsModal.call(self);
      //       // }
      //   });
      // });
  }

  setAsModal(){
    // const container = this.clientContext.uiContainer;
    // $(container).addClass('modal-style');
    // $('#input-password-screen').addClass('modal-content');
    // $('#input-password-screen-content').removeClass('bordered');
  }

  setAsScreen() {
    // const container = this.clientContext.uiContainer;
    // // $(container).removeClass('modal-style');
    // $('#input-password-screen').removeClass('modal-content');
    // $('#input-password-screen-content').addClass('bordered');
  }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default RegisterPassKeyFormSession;
